/**
 * Templates de tarefas que o ESCALA dispara AUTOMATICAMENTE depois do
 * diagnóstico (as 3 de "Entender" que rodam sem integração: benchmark,
 * tendências, concorrentes). O usuário NÃO criou essas — então elas não devem
 * "dar check" no passo "Crie sua primeira tarefa" dos primeiros passos.
 */
export const AUTO_ENTENDER_KEYS = [
  "analise_benchmark",
  "pesquisa_tendencias",
  "pesquisa_concorrentes",
] as const;

/** Uma tarefa conta como "criada pelo usuário" se NÃO for uma das auto do escala. */
export function isUserCreatedTask(templateKey: string | null | undefined): boolean {
  return !AUTO_ENTENDER_KEYS.includes((templateKey ?? "") as (typeof AUTO_ENTENDER_KEYS)[number]);
}
